import styled from 'styled-components';
import { colors } from '../../colors';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-left: 5px;
  margin-right: 5px;
  padding: 20px;
  text-align: center;
  font-size: 20px;

  .button {
    border: none;
      color: ${colors.create_mouseover};
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      margin: 4px 8px;
      cursor: pointer;
      border: 1px solid ${colors.create_mouseover};
      padding-left: 1.2em;
      padding-right: 1.2em;
    }

    button:hover {
      background-color: ${colors.create_mouseover};
        color: white;
    }`;
export const ConsentContainer = styled.div`
  margin-top: 0.8em;
  font-size: 0.875em;
  input[type="checkbox"] {
    margin: 0.250em 0.5em 0 0;
    outline: none;
  }
  .link {
    display: inline-block;
  }`;
export const ContryCodeContainer = styled.div`
.title {
	font-size: 2.75em;
	font-weight: lighter;
	text-align: center;
	width: 100%;
	margin-bottom: 0.5em !important;
}
p {
	display: inline-block;
	text-align: center;
	padding: 0 5em;
	width: 100%;
}
.flex {
	display: flex;
}
`;
export const FormFieldWrapperContainer = styled.div`
  border-radius: 0.7em;
  box-shadow: 0 0 1.875em 0 rgba(20, 20, 20, 0.1);
  margin: 0.75em 0;
  margin-top:1.em;
  text-align: left;
  line-height: 1.43;
  color: ${colors.textcolor};
  width: 98%;
  .err-msg {
    color: red;
    padding-left: 1em;
    padding-bottom: 0.5em;
    font-size: 0.875em;
  }
  label {
    padding: 1.125em 1.375em 0 0em;
    color: ${colors.lightgreycolor};
    font-size: 0.75em;
    margin-top: -1em;
    display: block;
  }
  input,
    select {
    margin: 0 1em 0.5em 0em;
    font-size: 1em;
    border: none;
    width: 100%;
    line-height: 2;
    cursor: text;
    outline: none;
    background: none;
  }
  select {
    -webkit-appearance: none;
    appearance: none;
    text-rendering: auto !important;
  }
  button {
    background-image: linear-gradient(to right, ${colors.darkBlue}, ${colors.greencolor});
    text-align: center;
    width: 100%;
    padding: 0.9em;
    font-size: 1em;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: ${colors.whitecolor};
    border-radius: 0.5em;
    outline: none;
    cursor: pointer;
  }
  .FormFieldWrapper:last-of-type {
    margin-top: 1.563em;
  }
  .inline {
    display: flex;
    margin-top: -1.5em;
    margin-bottom: -0.6em;

   .item {
     width: 50%;

    .FormFieldWrapper {
        margin-right: 0.5em;
        width: 97%;
    }
}

  .item:last-of-type {
    .FormFieldWrapper {
      margin-left: 0.5em;
    }
  }
}
.inlinefill {
  display: flex;
  margin-top: 1.5em;
  margin-bottom: -0.6em;
  .item {
      width: 50%;
      margin-bottom:1.3em;
      .FormFieldWrapper {
          margin-right: 0.5em;
          width: 97%;
      }
  }
  .item:last-of-type {
      .FormFieldWrapper {
          margin-left: 0.5em;
      }
  }
  }`;
export const SingleRowContainer = styled.div`
  display: flex;
  margin-top: -0.7em;
  .item {
      width: 100%;
      .FormFieldWrapper {
          margin-right: 0.5em;
          width: 97%;
      }
  }

  .item:last-of-type {
      .FormFieldWrapper {
          margin-left: 0.5em;
      }
  }`;
export const DoubleRowContainer = styled.div`
  display: flex;
  margin-top: -0.7em;
  .item {
      width: 50%;

      .FormFieldWrapper {
          margin-right: 0.5em;
          width: 98%;
      }
  }

  .item:last-of-type {
      .FormFieldWrapper {
          margin-left: 0.5em;
      }
  }`;
export const FormTitle = styled.div`
  font-size: 1.75em;
  font-weight: lighter;
  text-align: center;
  padding: 0 2em;
  margin-bottom:0.3em;`;

export const FormText = styled.div`
  text-align: center;
  padding: 0 2em;`;
export const KitActivationTitle = styled.div`
  font-size: 1.75em;
  font-weight: lighter;
  text-align: center;
  padding:1em;
	`;
export const ConfirmPopUpTitle = styled.div`
  font-size: 1.75em;
  font-weight: bold;
  text-align: center;
  padding:1em;
	`;
export const FormWidth = styled.div`
	width:50%;
	padding:0.2em;
	`;
export const CountryCodeWidth = styled.div`
	width:35%;
	padding: 0 0.5em;
	`;
export const PopUpTitle = styled.div`
  font-size: 1.75em;
  font-weight: bold;
  text-align: center;
  padding: 0 2em;
  margin-bottom:0.3em;`;
